module.exports = __webpack_public_path__ + "static/img/BMLP1.616f617.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/schoolEnrollment/BMLP1.jpg
// module id = pCdl
// module chunks = 1